import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import Carousel from "~/js/common/carousel";
import Favorite from "./favorite";
import HoverImage from "./hoverImage";
import HeaderMenu from "./headerMenu";
import Billboard from "./billboard";
import MorePickupItem from "./morePickupItem";
import MoreTopics from "./moreTopics";
import Selector from "./selector";
import Stickypin from "~/js/common/stickypin";
import Modal from "~/js/common/modal";
import Tooltip from "~/js/common/tooltip";
import ImportantModal from "~/js/common/important-modal";
import GlobalUsersModal from "../account/modal/globalUsersModal";
import _each from "lodash/each";
export default class PagesOnlinestore {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });

    if (
      navigator.userAgent.indexOf("iPhone") > 0 ||
      navigator.userAgent.indexOf("iPod") > 0 ||
      navigator.userAgent.indexOf("iPad") > 0 ||
      navigator.userAgent.indexOf("Android") > 0 ||
      (/android|ipod|ipad|iphone|macintosh/.test(navigator.userAgent.toLowerCase()) && "ontouchend" in document)
    ) {
      store.dispatch("setIsSP", {
        sta: true
      });
    }

    this.header = new Header();
    this.footer = new Footer();
    this.carousel = new Carousel();
    this.favorite = new Favorite(document.querySelector("._pickup_item"));
    this.hoverImage = new HoverImage(document.querySelector("._pickup_item"));
    this.headerMenu = new HeaderMenu();
    // this.billboard = new Billboard();
    this.morePickupItem = new MorePickupItem();
    this.moreTopics = new MoreTopics();
    this.setupSelector();
    this.stickyPin = new Stickypin();
    new ImportantModal();
    this.globalUsersModal = new GlobalUsersModal();

    this.modal = new Modal();
    this.tooltip = new Tooltip();
    store.dispatch("init");
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
  }

  setupSelector() {
    const selectors = document.querySelectorAll(".js-selectorwrap");
    _each(selectors, (wrap) => {
      let selector = wrap.querySelector(".c-selector");
      let isSticky = !wrap.getAttribute("data-nosticky");
      if (selector) {
        new Selector(selector, isSticky);
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new PagesOnlinestore();
});
